var React = require('react');

function DorWind (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Wind"),React.createElement("path",{"d":"M44,0c-7.7,0-14,6.3-14,14c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2c0-5.5,4.5-10,10-10s10,4.5,10,10s-4.5,10-10,10H2\n\tc-1.1,0-2,0.9-2,2s0.9,2,2,2h42c7.7,0,14-6.3,14-14S51.7,0,44,0z M74,10c-7.7,0-14,6.3-14,14c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2\n\tc0-5.5,4.5-10,10-10s10,4.5,10,10s-4.5,10-10,10H2c-1.1,0-2,0.9-2,2s0.9,2,2,2h72c7.7,0,14-6.3,14-14S81.7,10,74,10z M2,44\n\tc-1.1,0-2,0.9-2,2s0.9,2,2,2h54c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2\n\tc0,7.7,6.3,14,14,14s14-6.3,14-14s-6.3-14-14-14H2z","key":1})]);
}

DorWind.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 88 72","style":{"enableBackground":"new 0 0 88 72"},"xmlSpace":"preserve"};

module.exports = DorWind;

DorWind.default = DorWind;
